import React from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./card-media-layout.module.scss";

const cx = c.bind(styles);

export type CardMediaLayoutProps = BaseProps & {
  imageTop?: boolean;
};

const rootClassName = "purpur-card-media-layout";

export const CardMediaLayout = ({
  ["data-testid"]: dataTestId = "purpur-card-media-layout",
  className,
  children,
  imageTop = false,
  ...props
}: CardMediaLayoutProps) => (
  <div
    {...props}
    className={cx(rootClassName, className, { [`${rootClassName}--image-top`]: imageTop })}
    data-testid={dataTestId}
  >
    {children}
  </div>
);
